/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const router = new Router({
  mode: 'hash',
  //缓存滚动条
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  //去掉url中的# history
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/index'], resolve)
      }
    },
    {
      path: '/search_service',
      name: 'search_service',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/search_service'], resolve)
      }
    },{
      path: '/searchComplete',
      name: 'searchComplete',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/searchComplete'], resolve)
      }
    },{
      path: '/search',
      name: 'search',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/search'], resolve)
      }
    },
    {
      path: '/detail',
      name: 'detail',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/detail'], resolve)
      }
    },
    {
      path: '/time',
      name: 'time',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/time'], resolve)
      }
    },
    {
      path: '/detailspage',
      name: 'detailspage',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/detailspage'], resolve)
      }
    },{
      path: '/classification',
      name: 'classification',
      meta: {keepAlive: false},
      component: (resolve) => {
        require(['../views/classification'], resolve)
      }
    },{
      path: '/promotion',
      name: 'promotion',
      meta: {keepAlive: false},
      component: (resolve) => {
        require(['../views/promotion'], resolve)
      }
    },{
      path: '/comments',
      name: 'comments',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/comments'], resolve)
      }
    },{
      path: '/commentsInvalid',
      name: 'commentsInvalid',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/commentsInvalid'], resolve)
      }
    },{
      path: '/shoppingcar',
      name: 'shoppingcar',
      meta: {keepAlive: false},
      component: (resolve) => {
        require(['../views/shoppingcar'], resolve)
      }
    },{
      path: '/aboutdetailpage',
      name: 'aboutdetailpage',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/aboutdetailpage'], resolve)
      }
    },
    {
      path: '/reservation',
      name: 'reservation',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/reservation'], resolve)
      }
    },{
      path: '/choose',
      name: 'choose',
      meta: {keepAlive: false},
      component: (resolve) => {
        require(['../views/choose'], resolve)
      }
    },{
      path: '/coupon',
      name: 'coupon',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/coupon'], resolve)
      }
    },{
      path: '/pay',
      name: 'pay',
      meta: {keepAlive: false},
      component: (resolve) => {
        require(['../views/pay'], resolve)
      }
    },{
      path: '/choosepay',
      name: 'choosepay',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/choosepay'], resolve)
      }
    },
    {
      path: '/zhiyue',
      name: 'zhiyue',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/zhiyue'], resolve)
      }
    },
    {
      path: '/jishi',
      name: 'jishi',
      meta: {keepAlive: false},
      component: (resolve) => {
        require(['../views/jishi'], resolve)
      }
    },{
      path: '/techniciandetail',
      name: 'techniciandetail',
      meta: {keepAlive: true},
      props: (route) => ({ username: route.query.dwid }),
      component: (resolve) => {
        require(['../views/techniciandetail'], resolve)
      }
    },{
      path: '/technician',
      name: 'technician',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/technician'], resolve)
      },
    },
    {
      path: '/allorder',
      name: 'allorder',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/allorder'], resolve)
      }
    },
    {
      path: '/orderstate',
      name: 'orderstate',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/orderstate'], resolve)
      }
    },
    {
      path: '/orderStatusList',
      name: 'orderStatusList',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/orderStatusList'], resolve)
      }
    },
    {
      path: '/orderPayList',
      name: 'orderPayList',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/orderPayList'], resolve)
      }
    },
    {
      path: '/orderRemark',
      name: 'orderRemark',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/orderRemark'], resolve)
      }
    },
    {
      path: '/orderAddress',
      name: 'orderAddress',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/orderAddress'], resolve)
      }
    },
    {
      path: '/exchange',
      name: 'exchange',
      meta: {keepAlive: false},
      component: (resolve) => {
        require(['../views/exchange'], resolve)
      }
    },
    {
      path: '/addcomment',
      name: 'addcomment',
      meta: {keepAlive: false},
      component: (resolve) => {
        require(['../views/addcomment'], resolve)
      }
    },
    {
      path: '/refund',
      name: 'refund',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/refund'], resolve)
      }
    },
    {
      path: '/my',
      name: 'my',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/my'], resolve)
      }
    },
    {
      path: '/login',
      name: 'login',
      meta: {keepAlive: false},
      component: (resolve) => {
        require(['../views/login'], resolve)
      }
    },
    {
      path: '/position',
      name: 'position',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/position'], resolve)
      }
    },{
      path: '/address',
      name: 'address',
      meta: {keepAlive: false},
      component: (resolve) => {
        require(['../views/address'], resolve)
      }
    },
    {
      path: '/city',
      name: 'city',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/city'], resolve)
      }
    },
    {
      path: '/about',
      name: 'about',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/about'], resolve)
      }
    },
    {
      path: '/favor',
      name: 'favor',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/favor'], resolve)
      }
    },
    {
      path: '/qualifications',
      name: 'qualifications',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/qualifications'], resolve)
      }
    },
    {
      path: '/technicianimg',
      name: 'technicianimg',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/technicianimg'], resolve)
      }
    },
    {
      path: '/video',
      name: 'technicianvideo',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/video'], resolve)
      }
    },
    {
      path: '/try',
      name: 'try',
      meta: {keepAlive: false},
      component: (resolve) => {
        require(['../views/try'], resolve)
      }
    },
    {
      path: '/previewImage',
      name: 'previewImage',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/previewImage'], resolve)
      }
    },
    {
      path: '/confirmCode',
      name: 'confirmCode',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/confirmCode'], resolve)
      }
    },
    {
      path: '/payJump',
      name: 'payJump',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/payJump'], resolve)
      }
    },
    {
      path: '/feeStandard',
      name: 'feeStandard',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/feeStandard'], resolve)
      }
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      meta: {keepAlive: true},
      component: (resolve) => {
        require(['../views/paySuccess'], resolve)
      }
    }
  ]
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js